var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":function($event){return _vm.axiosGet()}}},[_vm._v("Axios Get")]),_c('button',{on:{"click":function($event){return _vm.axiosPost()}}},[_vm._v("Axios Post")]),_c('button',{on:{"click":function($event){return _vm.axiosPUT()}}},[_vm._v("Axios PUT")]),_c('sampleComponent',{attrs:{"testMsg":_vm.sampleData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }